import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card card-default" }
const _hoisted_3 = { class: "card-header feature-header" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-auto me-auto" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "col-auto" }
const _hoisted_8 = { class: "card-body card-body-custom-layout" }
const _hoisted_9 = { class: "card-body-grid" }

import './BaseGridView.Component.css';
// import {getCurrentInstance, ComponentPublicInstance} from 'vue';
import CompanyCommonComponent from "@/components/poweroffice/common/CompanyCommonComponent.vue";
import agent, { powerOfficeServiceBaseURL } from "@/services/agent";
import { L10n, setCulture } from "@syncfusion/ej2-base";
import {
  ColumnModel,
  CommandColumn,
  GridComponent,
  Page,
  Resize,
  Search,
  Sort,
  Toolbar,
} from "@syncfusion/ej2-vue-grids";
import {
  getCurrentInstance,
  onBeforeMount,
  onMounted,
  provide,
  ref,
  watch,
} from "vue";
import { useI18n } from "vue-i18n";
import {
  DataProperty,
  GridData,
  GridResponse,
  SearchOption,
  TemplateDef,
} from "./CommonInterfaces";
import CardTitleComponent from '@/components/common/CardTitleComponent.vue';
import SearchComponent from '@/components/shared/SearchComponent.vue';

// grid settings
interface PropDefinition {
  endpoint: string;
  pageTitle?: string;
  searchOptions?: SearchOption;
  columnDef: ColumnModel[];
  localizedGridData?: object;
  templateDef?: TemplateDef;
  modifyData?: (response: DataProperty) => DataProperty;
  commandClick?: (commandTitle: string, rowData: any) => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseGridView.Component',
  props: {
    endpoint: {},
    pageTitle: {},
    searchOptions: {},
    columnDef: {},
    localizedGridData: {},
    templateDef: {},
    modifyData: { type: Function },
    commandClick: { type: Function }
  },
  setup(__props: any) {


provide("grid", [Toolbar, Resize, Search, CommandColumn, Page, Sort]);
const toolbar = ["Search"];
const pageSettings = {
  pageSizes: [10, 20, 50, 100],
  pageSize: 50,
  pageCount: 5,
};
const defaultState = {
  skip: 0,
  take: pageSettings.pageSize,
};

const props = __props;

const app = getCurrentInstance();

const columnDef = ref(props.columnDef);

onBeforeMount(() => {
  // comInstance = app!.proxy!;

  agent.setBaseUrl(powerOfficeServiceBaseURL);
  localizeGrid();
});

onMounted(() => {
  onDataStateChange(defaultState);
});

const onDataStateChange = (state: any) => {
  localizeGrid();
  fetchData(state);
};

const onCommandClick = (args: { commandColumn: any; rowData: any }) => {
  if (props.commandClick) {
    props.commandClick(args.commandColumn.title, args.rowData);
  }
};

let companyIdUpdated = ref(0);
const onCompanyChange = (companyId: number) => {
  companyIdUpdated.value = companyId;
  fetchData(defaultState);
};

let langLocale = ref("en-grid");
const { locale } = useI18n();
// eslint-disable-next-line no-unused-vars
watch(locale, (_newVal, _oldVal) => {
  localizeGrid();

  columnDef.value = getRevisedColumnDef();
});

const getRevisedColumnDef = () => {
  const instance = app?.proxy;

  let columnDefs = [...props.columnDef];

  columnDefs.forEach((column) => {
    column.headerText = instance?.$t(`${headerReplace(column?.field)}`);
  });

  return columnDefs;
};

const localizeGrid = () => {
  const langGrid = locale.value === "se" ? "se-grid" : "en-grid";
  langLocale.value = langGrid;
  setCulture(langGrid);

  if (langGrid === "se-grid") {
    if (props.localizedGridData) {
      L10n.load({ ...props.localizedGridData });
    } else {
      L10n.load({ ...gridLocal });
    }
  }
};

const baseDataGrid = ref<any | null>(null);
const searchText = ref('');
const searchOptions = ref<SearchOption>({
  fields: [],        // fill with the fields you want to search
  operator: 'contains',
  ignoreCase: true,
  key: ''
});

const onSearch = (text: string) => {
  searchText.value = text;
  searchOptions.value = {
    ...searchOptions.value,
    key: text
  };
  const grid = baseDataGrid.value?.ej2Instances;
  if (grid) {
    grid.search(text);         // Syncfusion global search call
  }
};
const clearSearch = () => {
  searchText.value = '';
  searchOptions.value = {
    ...searchOptions.value,
    key: ''
  };
  const grid = baseDataGrid.value?.ej2Instances;
  if (grid) {
    grid.search('');           // clear search
  }
};
let dataSource = ref({} as GridData);

const fetchData = (state: any) => {
  if (state.action) {
    delete state.action;
  }

  const gridTable: any = baseDataGrid.value;
  if (gridTable) {
    gridTable.hideSpinner();
  }

  agent
    .post<GridResponse>(props.endpoint, {
      ...state,
      companyId: companyIdUpdated.value,
    })
    .then((response) => {
      if (response.result) {
        dataSource.value = response.result;
      }
    })
    .catch((err) => {
      console.error("api-call-error: ", err);
    });
};

// /Some of the columns have TimeOffset in the field Name
/// but not exist in locale, this function removes it
const headerReplace = (header?: string) => {
  return header?.replace("TimeOffset", "")?.replace("isActive", "status");
};

const gridLocal = {
  "se-grid": {
    grid: {
      EmptyRecord: "Inga poster visas",
      Search: "Sök",
      GroupDropArea: "Dra en kolumnrubrik hit för att gruppera din kolumn",
      UnGroup: "Klicka här för att avgruppera",
      EmptyDataPageError:
        "DataPage får inte vara tom vid den första laddningen eftersom kolumner från dataPage finns i AutoGenerate Column Grid",
      Item: "Artikel",
      Items: "Artikel",
    },
    pager: {
      currentPageInfo: "{0} av {1} sidor",
      totalItemsInfo: "({0} inlägg)",
      firstPageTooltip: "Till första sidan",
      lastPageTooltip: "Till sista sidan",
      nextPageTooltip: "Till nästa sida",
      previousPageTooltip: "Tillbaka till sista sidan",
      nextPagerTooltip: "Till nästa personsökare",
      previousPagerTooltip: "Gå till föregående personsökare",
      pagerDropDown: "Objekt per sida",
    },

  },
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(CardTitleComponent)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(SearchComponent, {
              modelValue: searchText.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
              onSearch: onSearch,
              onClear: clearSearch
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(CompanyCommonComponent, { onOnCompanyChange: onCompanyChange })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(GridComponent), {
            ref_key: "baseDataGrid",
            ref: baseDataGrid,
            dataSource: _unref(dataSource),
            columns: columnDef.value,
            autoFit: true,
            allowPaging: true,
            allowSorting: true,
            allowMultiSorting: true,
            allowResizing: true,
            searchSettings: searchOptions.value,
            pageSettings: pageSettings,
            locale: _unref(langLocale),
            rowHeight: 30,
            height: "100%",
            commandClick: onCommandClick,
            dataStateChange: onDataStateChange
          }, _createSlots({ _: 2 }, [
            _renderList(__props.templateDef?.columnNames, (columnName) => {
              return {
                name: `${__props.templateDef?.prefix}_${columnName}`,
                fn: _withCtx(({ data }) => [
                  _renderSlot(_ctx.$slots, `${__props.templateDef?.prefix}_${columnName}`, {
                    rowData: {
                field: columnName,
                value: data[columnName],
              }
                  })
                ])
              }
            })
          ]), 1032, ["dataSource", "columns", "searchSettings", "locale"])
        ])
      ])
    ])
  ]))
}
}

})